import './context-heading.scss';

/**
 * version    1.0
 * class      <type> (ContextHeading)
 * classdesc  Context Heading: contains one image bg, icon, occhiello, title and an abstract on the right
 */
export class ContextHeading {}
